var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('StandardCard',{attrs:{"title":_vm.title,"subheader":"INFO","loading":_vm.loading},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('CardContent',{model:{value:(_vm.info),callback:function ($$v) {_vm.info=$$v},expression:"info"}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }